import { CALL_API, METHOD_TYPE } from '../../middleware/api.middleware'

/**
 * Dashboard Action Type Constants
 * @type {string}
 */
export const GET_CONTACTS_BREAKDOWN_REQUEST = 'GET_CONTACTS_BREAKDOWN_REQUEST'
export const GET_CONTACTS_BREAKDOWN_SUCCESS = 'GET_CONTACTS_BREAKDOWN_SUCCESS'
export const GET_CONTACTS_BREAKDOWN_FAILURE = 'GET_CONTACTS_BREAKDOWN_FAILURE'

/**
 * Get Contact Breakdown
 * @returns {{}}
 * @private
 */
const _getContactsBreakdown = () => ({
  [CALL_API]: {
    types: [
      GET_CONTACTS_BREAKDOWN_REQUEST,
      GET_CONTACTS_BREAKDOWN_SUCCESS,
      GET_CONTACTS_BREAKDOWN_FAILURE
    ],
    method: METHOD_TYPE.GET,
    endpoint: '/contact/breakdown'
  }
})

/**
 * Dispatch GET_CONTACTS_BREAKDOWN_REQUEST
 */
export const getContactsBreakdown = () => (dispatch) =>{
  return dispatch(_getContactsBreakdown())
}
